import { useCallback } from 'react';

import { useRouter } from 'next/navigation';

import { ROUTES } from '@shared/constants/routes';
import { useAppDispatch } from '@shared/hooks/redux';
import { openAuthModal } from '@widgets/Auth';
import { refreshAccessToken } from '@widgets/Auth/api/refreshAccessToken/refreshAccessToken';

export const useClickMenuItem = () => {
  const dispatch = useAppDispatch();

  const { push } = useRouter();

  return useCallback(
    async (href: string) => {
      if ([ROUTES.FAVORITES, ROUTES.COMPARISON, ROUTES.CART].includes(href as ROUTES)) {
        push(href);
        return;
      }

      const { ok } = await refreshAccessToken();

      if (ok) {
        push(href);
      } else {
        dispatch(openAuthModal({ linkAfterLogin: href }));
      }
    },
    [dispatch, push]
  );
};
